export const newSortingOptions = (feature, order, code) => ({
  feature,
  order,
  code,
})
